module.exports = __webpack_public_path__ + "static/media/10-02.84ede8bf.png";